import { useState, useEffect } from 'react';
import './CookieBanner.css';

function CookieBanner({ onOpenLegal }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('rocaille_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('rocaille_cookie_consent', 'all');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('rocaille_cookie_consent', 'necessary');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <p className="cookie-banner__title">Cookies &amp; Datenschutz</p>
          <p className="cookie-banner__desc">
            Wir verwenden Cookies und ähnliche Technologien, um Ihnen die bestmögliche Erfahrung
            auf unserer Website zu bieten. Einige sind technisch notwendig, andere helfen uns,
            die Website zu verbessern und Inhalte zu personalisieren.
            {' '}
            <button
              className="cookie-banner__link"
              onClick={() => onOpenLegal('datenschutz')}
            >
              Datenschutzerklärung
            </button>
          </p>
        </div>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__btn cookie-banner__btn--secondary" onClick={decline}>
            Nur notwendige
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--primary" onClick={accept}>
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
